import { TvBaseColumns } from './TvBaseColumns';
class _TvOrderColumns extends TvBaseColumns {
    getOrderColumns() {
        const symbol = this.createColumnItem('panel.orders.symbol', 'symbol', "symbol" /* StandardFormatterName.Symbol */);
        const side = this.createColumnItem('panel.orders.action', 'side', "side" /* StandardFormatterName.Side */);
        const type = this.createColumnItem('panel.orders.type', 'type', "type" /* StandardFormatterName.Type */, false, [
            'type',
            'parentId',
            'stopType'
        ]);
        const qty = this.createColumnItem('panel.orders.quantity', 'qty', "formatQuantity" /* StandardFormatterName.FormatQuantity */);
        const qtyrem = this.createColumnItem('panel.orders.QuantityRemaining', 'qtyrem', "formatQuantity" /* StandardFormatterName.FormatQuantity */);
        const limitPrice = this.createColumnItem('panel.orders.price', 'limitPrice', "formatPrice" /* StandardFormatterName.FormatPrice */);
        const stopPrice = this.createColumnItem('panel.orders.StopPrice', 'stopPrice', "formatPrice" /* StandardFormatterName.FormatPrice */);
        const last = this.createColumnItem('panel.orders.CurrentPrice', 'last', "formatPrice" /* StandardFormatterName.FormatPrice */, true);
        const tif = this.createColumnItem('panel.orders.TIF', 'tif', "text" /* StandardFormatterName.Text */);
        const stopLoss = this.createColumnItem('panel.orders.SL', 'stopLoss', "formatPrice" /* StandardFormatterName.FormatPrice */);
        const takeProfit = this.createColumnItem('panel.orders.TP', 'takeProfit', "formatPrice" /* StandardFormatterName.FormatPrice */);
        // supportedStatusFilters: [0]
        const status = this.createColumnItem('panel.orders.Status', 'status', "status" /* StandardFormatterName.Status */);
        const filledQty = this.createColumnItem('panel.orders.QuantityFilled', 'filledQty', "formatQuantity" /* StandardFormatterName.FormatQuantity */);
        const id = this.createColumnItem('panel.orders.Reference', 'id', "text" /* StandardFormatterName.Text */);
        const date = this.createColumnItem('panel.orders.date_time', 'date', "localDateOrDateTime" /* StandardFormatterName.LocalDateOrDateTime */);
        const columns = [
            symbol,
            side,
            type,
            qty,
            qtyrem,
            limitPrice,
            stopPrice,
            last,
            tif,
            stopLoss,
            takeProfit,
            status,
            filledQty,
            id,
            date
        ];
        return columns.filter((c) => c !== null);
    }
}
export const TvOrderColumns = new _TvOrderColumns();
